import React from "react";
import styled from "styled-components";

export default function Button(props) {
  const Button = styled.button`
    margin: ${props.margin};
    color: ${props.color};
    background-color: ${props.backgroundColor};
    width: ${props.width};
    height: ${props.height};
    font-weight: ${props.fontWeight};
    border: none;
    border-radius: ${props.borderRadius};
    cursor: pointer;
    padding: ${props.padding};
  `;

  return props.disabled ? (
    <Button disabled>{props.children}</Button>
  ) : (
    <Button onClick={props.onClick}>{props.children}</Button>
  );
}
